module.exports = __webpack_public_path__ + "static/005.thumb-2f36025034f18bfe928b4a86c2e6286d.jpg";